module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "width": "50%",
      "title": _vm.note && _vm.note.flagged ? 'Unflag Voice Note' : 'Flag for Review',
      "destroy-on-close": "",
      "visible": _vm.internalVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.internalVisible = $event
      },
      "close": _vm.handleClose
    }
  }, [(_vm.note) ? _c('div', [_c('div', {
    staticClass: "modal-meta"
  }, [_c('div', {
    staticClass: "meta-item"
  }, [_c('i', {
    staticClass: "el-icon-user"
  }), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.note.sender))])])]), _vm._v(" "), (_vm.note.timestamp) ? _c('div', {
    staticClass: "meta-item"
  }, [_c('i', {
    staticClass: "el-icon-time"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatDate(_vm.note.timestamp)))])]) : _vm._e(), _vm._v(" "), (_vm.note.flagged) ? _c('el-tag', {
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "mini",
      "type": "danger",
      "effect": "dark"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag"
  }), _vm._v(" Currently Flagged\n      ")]) : _c('el-tag', {
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "mini",
      "type": "info",
      "effect": "plain"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o"
  }), _vm._v(" Not Flagged\n      ")])], 1), _vm._v(" "), _c('el-card', {
    staticClass: "transcript-card",
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('i', {
    staticClass: "el-icon-document"
  }), _vm._v(" Transcript Preview\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "transcript-text"
  }, [_vm._v(_vm._s(_vm.previewText))])]), _vm._v(" "), (_vm.note.flagged) ? _c('div', {
    staticClass: "previous-flag"
  }, [_c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag"
  }), _vm._v(" Previous Flag Info\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "flag-info"
  }, [(_vm.note.flaggedBy) ? _c('div', {
    staticClass: "flag-info-item"
  }, [_c('span', {
    staticClass: "flag-label"
  }, [_vm._v("Flagged by")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "size": "mini",
      "type": "danger",
      "effect": "plain"
    }
  }, [_c('i', {
    staticClass: "el-icon-user"
  }), _vm._v(" " + _vm._s(_vm.note.flaggedBy) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.note.flaggedAt) ? _c('div', {
    staticClass: "flag-info-item"
  }, [_c('span', {
    staticClass: "flag-label"
  }, [_vm._v("Flagged on")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "size": "mini",
      "type": "info",
      "effect": "plain"
    }
  }, [_c('i', {
    staticClass: "el-icon-time"
  }), _vm._v(" " + _vm._s(_vm.formatDate(_vm.note.flaggedAt)) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.note.flagReason) ? _c('div', {
    staticClass: "flag-info-item"
  }, [_c('span', {
    staticClass: "flag-label"
  }, [_vm._v("Comment")]), _vm._v(" "), _c('span', {
    staticClass: "flag-reason"
  }, [_vm._v(_vm._s(_vm.note.flagReason))])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-position": "top",
      "size": "small"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Action By"
    }
  }, [_c('el-input', {
    attrs: {
      "value": _vm.actionBy,
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-user el-input__icon",
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Date"
    }
  }, [_c('el-input', {
    attrs: {
      "value": _vm.actionDate,
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-date el-input__icon",
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  })])], 1), _vm._v(" "), (!_vm.note.flagged) ? _c('el-form-item', {
    attrs: {
      "label": "Reason / Comments (optional)"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "Leave a reason or comment...",
      "rows": 3,
      "maxlength": "300",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.note && _vm.note.flagged) ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.handleFlag(false)
      }
    }
  }, [_vm._v("\n      Unflag Voice Note\n    ")]) : _c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger",
      "icon": "fa fa-flag",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.handleFlag(true)
      }
    }
  }, [_vm._v("\n      Flag for Review\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d6a89be","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/analytics/voiceIntelligence/modals/FlagModal.vue
// module id = 3199
// module chunks = 3